import axios, { Canceler } from 'axios'
import { EnhancedWithAuthHttpService } from './http-auth.service'

import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'
import {
  EMediaConnectionType,
  ICreateMediaDto,
  IMediaConnectionItems,
  IMediaListRespDto,
  IMessageResponseDto,
} from 'src/types'

class MediaListService extends EnhancedWithAuthHttpService {
  CancelToken
  cancel?: Canceler
  constructor() {
    super(new HttpService(axiosInstance))
    this.CancelToken = axios.CancelToken
  }

  getMediaConnections(type: EMediaConnectionType) {
    return this.get<IMediaConnectionItems>(`media/connections/${type}`)
  }

  getMedia(params?: {}) {
    if (this.cancel) {
      this.cancel()
    }

    return this.get<IMediaListRespDto>('media', {
      params,
      cancelToken: new this.CancelToken((c) => {
        this.cancel = c
      }),
    })
  }

  createMedia(dto: ICreateMediaDto) {
    return this.post('media', dto)
  }

  deleteMedia(ids: string[]) {
    return this.delete<IMessageResponseDto>('media', { data: { ids } })
  }
}

export const mediaListService = new MediaListService()
export default MediaListService
